(ns manage.content-configuration-page.view.save
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [clojure.string :as str]
            [common.modal.view :refer [modal defmodal]]
            [common.widgets.details :refer [details]]
            [common.widgets.table :as t]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-event-db ::save-failure
  [(rf/path [:page.content-configuration :save-in-progress?])]
  (fn [_ _]
    false))

(rf/reg-event-db ::start-save
  [(rf/path [:page.content-configuration :save-in-progress?])]
  (fn [_ _]
    true))

(rf/reg-event-db ::save-success
  [(rf/path [:page.content-configuration])]
  (fn [db _]
    (dissoc db :log-unsaved-transactions :save-in-progress?)))

(rf/reg-event-db ::log-unsaved-transaction
  [(rf/path [:page.content-configuration :log-unsaved-transactions])]
  (fn [log-unsaved-transactions [_ tx-data transaction-id]]
    (assoc log-unsaved-transactions transaction-id tx-data)))

(rf/reg-sub ::unsaved-transactions
  :<- [:page.content-configuration]
  (fn [db _]
    (:log-unsaved-transactions db)))

(rf/reg-sub ::num-unsaved-transactions-failed
  :<- [:page.content-configuration]
  (fn [{:keys [save-in-progress? log-unsaved-transactions]} _]
    (when-not save-in-progress?
      (count log-unsaved-transactions))))

(defui unsaved-transactions []
  (let [num-unsaved (use-subscribe [::num-unsaved-transactions-failed])]
    (when (pos? num-unsaved)
      ($ Alert {:severity "error"
                :style {:margin-left "0"}
                :sx #js {:position "absolute"
                         :top 0
                         :left 0
                         :right 0
                         :zIndex 1000}}
         ($ :p
            "There " (if (= num-unsaved 1) "is" "are")
            " currently " num-unsaved " unsaved change" (when (not= num-unsaved 1) "s") "!")
         ($ Link
            {:color "inherit"
             :on-click #(rf/dispatch
                         [:modal/open {:id :manage.content-configuration-page.view.save/cfn-save-error-results}])}
            "More info")))))

(defn changelog
  "Convert the list of unsaved transactions to a flat list of changes per
  entity+attribute. Then merge related changes (consecutive changes to the
  same entity+attribute to a single entry."
  [unsaved-transactions]
  (let [datoms (apply concat (vals unsaved-transactions))
        changes-per-property (group-by (juxt :tx :e :a) datoms)
        changelog (for [[[tx-id eid attr] changes] changes-per-property
                        [old new] (partition 2 (map :v (sort-by (juxt :tx :added) changes)))]
                    {:tx-id tx-id
                     :previous-value old
                     :new-value new
                     :eid eid
                     :attr attr})]
    (sort-by :tx-id (reduce (fn [res c]
                              (let [[f & r] res]
                                (if (and f (= (:eid f) (:eid c)) (= (:attr f) (:attr c)))
                                  (conj r (assoc c :previous-value (:previous-value f)))
                                  (conj res c))))
                            '()
                            (sort-by (juxt :eid :attr) changelog)))))

(rf/reg-sub ::changelog
  :<- [::unsaved-transactions]
  (fn [unsaved-transactions _]
    (changelog unsaved-transactions)))

(defn show-change [{:keys [attr previous-value new-value]}]
  [t/table-row {}
   [t/table-cell {:style {:white-space "normal"}} (str/replace (str (namespace attr) " " (name attr)) "-" " ")]
   [t/table-cell {:style {:white-space "normal"}} (pr-str previous-value)]
   [t/table-cell {:style {:white-space "normal"}} (pr-str new-value)]])

(defmodal show-cfn-service-error-modal ::cfn-save-error-results
  [result]
  (let [changelog (not-empty @(rf/subscribe [::changelog]))
        bad-request (= (:status result) 400)]
    [modal {:title "Something has blocked the platform from saving"
            :footer [:> Button {:variant "contained" :on-click #(rf/dispatch [:modal/close])}
                     "OK"]
            :modifier :error}
     [:> Stack {:spacing 2}

      (if bad-request
        [:p "It could be that your configuration contains errors. You may need
        to make some changes before your content configuration can be saved
        again."]

        [:p "Something went wrong while trying to save your latest change to our
        servers. Please try again. If the problem persists, please contact our
        support team."])

      (when changelog
        [:> Stack {:spacing 1}
         (if bad-request
           [:p "Could it be that the following change"
            (if (= (count changelog) 1) " has" "s have")
            " caused this issue?"]
           [:p "The following changes could not be stored:"])
         [t/table {:style {:min-height 0}}
          [t/table-row {}
           [t/table-head {:style {:white-space "normal"}} "property"]
           [t/table-head {:style {:white-space "normal"}} "previous value"]
           [t/table-head {:style {:white-space "normal"}} "new value (not saved)"]]
          (for [{:keys [tx-id eid attr] :as change} changelog]
            ^{:key [tx-id eid attr]} [show-change change])]])
      (when result
        [details (str "Click here to see what the " (get-in result [:value :error :spec :source] "server") " said")
         [:p (get-in result [:value :error :message])]
         [:p (get-in result [:value :error :spec :category])]
         [:> Typography {:component "code"
                         :font-size "caption.fontSize"
                         :font-family "monospace"}
          (get-in result [:value :error :spec :error :message])]])]]))
